import { apiClient } from "@/api";
import { CheckIn, CreateAsset } from "@/api/generated/data-contracts";

export async function checkInExistingDevice(assetId: number, checkIn: CheckIn) {
  const response = await apiClient.assetsCheckInCreate(assetId, checkIn);

  if (!response.ok) {
    throw response;
  }

  return response.data;
}

export async function checkInNewDevice(device: CreateAsset) {
  const response = await apiClient.assetsCheckInCreate2(device);

  if (!response.ok) {
    throw response;
  }

  return response.data;
}
